import { ChangeDetectionStrategy, Component, computed, effect, inject, Injector, input } from '@angular/core';
import { CreateEventFormStore } from '../../new-event-form/_services/create-event-form-store.service';
import { StreappEventsService } from 'src/app/services/streapp-events.service';
import { AuthService } from 'src/app/services/auth.service';
import { of, switchMap, tap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SimilarEventsDialogComponent } from '../../_components/similar-events-dialog/similar-events-dialog.component';
import { StreappEvent } from 'src/app/models/streappevent.model';
import { LocationSelectorService } from '../../_components/location-selector-azure/service/location-selector.service';
import { FormGroup } from '@angular/forms';
import { EventForm } from '../../_models/event-form.model';
import { EditEventFormStore } from '../../edit-event-form/_services/edit-event-form-store.service';

@Component({
  selector: 'location-selection-step',
  standalone: false,
  templateUrl: './location-selection-step.component.html',
  styleUrl: './location-selection-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class LocationSelectionStepComponent {
  edit = input<boolean>(false);
  public initLatLng = input<number[] | null>(null);

  public selectedLatLng: number[] | null = null;
  private initializedFromInput = false;
  
  public locationAdress: string;
  
  public formGroup = input.required<FormGroup<EventForm>>();

  private injector = inject(Injector);

  public eventFormStore = computed(() =>
    this.edit()
      ? this.injector.get(EditEventFormStore)
      : this.injector.get(CreateEventFormStore)
  );

  private readonly streappService = inject(StreappEventsService);

  private readonly authService = inject(AuthService);

  private readonly dialog = inject(MatDialog);

  private readonly locationSelectorService = inject(LocationSelectorService);

  constructor() {
    effect(() => {
      if (this.initializedFromInput) return;

      const initial = this.initLatLng();
      if (!initial) return;

      this.selectedLatLng = initial;
      this.initializedFromInput = true;
      this.eventFormStore().stepLocationValid.set(true);
    });
  }

  async setLocation(location: number[]) {
    this.eventFormStore().updateLocation(location[1], location[0], this.locationAdress);

    this.selectedLatLng = location;

    this.eventFormStore().stepLocationValid.set(true);

    if(!this.edit()) {
      this.checkSimilarEvents();
    }
  }

  // Called when location changes in azure map
  setAdress(location: string): void {
    this.locationAdress = location
    this.eventFormStore().updateLocation(this.selectedLatLng[1], this.selectedLatLng[0], this.locationAdress);
  }

  checkSimilarEvents(): void {
    this.streappService
      .getNearbyEvents(
        this.selectedLatLng[0],
        this.selectedLatLng[1],
        this.authService.authorizationHeaderValue
      ).pipe(
        switchMap((data: Array<StreappEvent>) => {
          if (!data || data.length === 0) {
            const store = this.eventFormStore();
            if(store instanceof CreateEventFormStore) {
              store.resetLinkedEvent();
            }
            return of(null);
          }

          // Open dialog and return its obserable
          return this.dialog.open<SimilarEventsDialogComponent>(SimilarEventsDialogComponent, {
            data: data,
          }).afterClosed();
        }),

        tap((selectedEvent) => {
          if (!selectedEvent) {
            return;
          }
            
          const store = this.eventFormStore() as CreateEventFormStore;

          if (selectedEvent.result === 'link') {
            store.linkEvent(selectedEvent.event);
            this.formGroup().controls.detailsForm.controls.titel.setValue(selectedEvent.event.title);
            store.stepLocationValid.set(true);
          } else if (selectedEvent.result === 'new') {
            store.resetLinkedEvent();
            this.formGroup().controls.detailsForm.controls.titel.reset();
            store.stepCategoryValid.set(false);
            store.stepDetailsValid.set(false);
            store.stepPrivacyValid.set(false);
            store.stepPriceValid.set(false);
          } else if (selectedEvent.result === 'cancel') {
            store.resetLinkedEvent();
            store.updateLocation(0, 0, this.locationAdress);
            this.locationSelectorService.resetLocation();
            this.formGroup().controls.detailsForm.controls.titel.reset();
            store.stepLocationValid.set(false);
            store.stepCategoryValid.set(false);
            store.stepDetailsValid.set(false);
            store.stepPrivacyValid.set(false);
            store.stepPriceValid.set(false);
          }
        })
      ).subscribe();
  }
}
